<template>
  <div class="public-profile">
    <PublicProfileHeader
      :active-tab="0"
      @user-loaded="onUserLoaded"
      @connections-loaded="onConnectionsLoaded"
    />

    <!-- Profile Content -->
    <template v-if="userLoaded">
      <!-- Tab Content -->
      <v-container class="profile-body">
        <v-row class="profile-filter-row">
          <v-col
            class="text-center"
            cols="12"
          >
            <div class="tw-toggle">
              <input
                id="public-profile-personal"
                type="radio"
                name="public-profile-toggle"
                value="false"
                :checked="content_type === 0"
                @click="checkContentType(0)"
              />
              <label
                for="public-profile-personal"
                class="toggle toggle-yes"
              >
                <v-icon
                  :class="{'alternate-icon-small': !mdiAccount}"
                  class="mx-auto"
                >
                  {{ mdiAccount }}
                </v-icon>
              </label>
              <input
                id="public-profile-both"
                type="radio"
                name="public-profile-toggle"
                value="-1"
                :checked="content_type === -1"
                @click="checkContentType(-1)"
              />
              <label
                for="public-profile-both"
                class="toggle toggle-yes"
              >
                <v-icon
                  :class="{'alternate-icon-small': !mdiAccountMultiple}"
                  class="mx-auto"
                >
                  {{ mdiAccountMultiple }}
                </v-icon>
              </label>
              <input
                id="public-profile-professional"
                type="radio"
                name="public-profile-toggle"
                value="true"
                :checked="content_type === 1"
                @click="checkContentType(1)"
              />
              <label
                for="public-profile-professional"
                class="toggle toggle-yes"
              >
                <v-icon
                  :class="{'alternate-icon-small': !mdiAccountTie}"
                  class="mx-auto"
                >
                  {{ mdiAccountTie }}
                </v-icon>
              </label>
              <span></span>
            </div>
          </v-col>
        </v-row>

        <v-row class="profile-filter-row">
          <div class="d-flex justify-center wrapper-menu">
            <template v-if="$vuetify.breakpoint.mdAndDown">
              <v-list class="mobile--menu-list">
                <v-list-group :value="false">
                  <template v-slot:activator>
                    <v-list-item-title>Categories</v-list-item-title>
                  </template>

                  <template v-if="!content_type || content_type === -1">
                    <div
                      v-for="(item, i) in categories"
                      :key="`profile-system-${i}`"
                    >
                      <v-list-item
                        v-if="!item.children"
                        class="single_item"
                        link
                        @click="searchCategory(item.id)"
                      >
                        <span>-</span> {{ item.name }}
                      </v-list-item>
                      <div v-else>
                        <v-list-group
                          :value="false"
                          no-action
                          sub-group
                        >
                          <template v-slot:activator>
                            <v-list-item-title @click="searchCategory(item.id)">
                              {{ item.name }}
                            </v-list-item-title>
                          </template>
                          <div
                            v-for="itemL1 in item.children"
                            :key="`profile-system-L-${itemL1.id}`"
                          >
                            <v-list-item
                              v-if="!itemL1.children"
                              class="single_item"
                              link
                              @click="searchCategory(itemL1.id)"
                            >
                              <span>-</span> {{ itemL1.name }}
                            </v-list-item>
                            <v-list-group
                              v-else
                              :value="false"
                              no-action
                              sub-group
                            >
                              <template v-slot:activator>
                                <v-list-item-title @click="searchCategory(itemL1.id)">
                                  {{ itemL1.name }}
                                </v-list-item-title>
                              </template>
                              <v-list-item
                                v-for="(itemL2, index) in itemL1.children"
                                :key="`profile-system-L2-${index}`"
                                class="single_item"
                                link
                                @click="searchCategory(itemL2.id)"
                              >
                                <span>-</span> {{ itemL2.name }}
                              </v-list-item>
                              <v-divider></v-divider>
                            </v-list-group>
                          </div>
                          <v-divider></v-divider>
                        </v-list-group>
                      </div>
                    </div>
                  </template>

                  <template v-if="content_type || content_type === -1">
                    <div
                      v-for="(item, i) in professionalCategories"
                      :key="`profile-prof-${i}`"
                    >
                      <v-list-item
                        v-if="!item.children"
                        class="single_item"
                        link
                        @click="searchCategory(item.id)"
                      >
                        <span>-</span> {{ item.name }}
                      </v-list-item>
                      <div v-else>
                        <v-list-group
                          :value="false"
                          no-action
                          sub-group
                        >
                          <template v-slot:activator>
                            <v-list-item-title @click="searchCategory(item.id)">
                              {{ item.name }}
                            </v-list-item-title>
                          </template>
                          <div
                            v-for="itemL1 in item.children"
                            :key="`profile-prof-L-${itemL1.id}`"
                          >
                            <v-list-item
                              v-if="!itemL1.children"
                              class="single_item"
                              link
                              @click="searchCategory(itemL1.id)"
                            >
                              <span>-</span> {{ itemL1.name }}
                            </v-list-item>
                            <v-list-group
                              v-else
                              :value="false"
                              no-action
                              sub-group
                            >
                              <template v-slot:activator>
                                <v-list-item-title @click="searchCategory(itemL1.id)">
                                  {{ itemL1.name }}
                                </v-list-item-title>
                              </template>
                              <v-list-item
                                v-for="(itemL2, index) in itemL1.children"
                                :key="`profile-prof-L2-${index}`"
                                class="single_item"
                                link
                                @click="searchCategory(itemL2.id)"
                              >
                                <span>-</span> {{ itemL2.name }}
                              </v-list-item>
                              <v-divider></v-divider>
                            </v-list-group>
                          </div>
                          <v-divider></v-divider>
                        </v-list-group>
                      </div>
                    </div>
                  </template>

                  <v-divider></v-divider>
                  <v-list-item
                    class="single_item"
                    :class="{ 'active': categorySelected === '' }"
                    @click="searchCategory(-1)"
                  >
                    - All
                  </v-list-item>
                </v-list-group>
              </v-list>
            </template>

            <div
              v-if="!$vuetify.breakpoint.mdAndDown"
              class="inner-wrapper-menu"
            >
              <ul
                v-if="!content_type || content_type === -1"
                class="list-menu clearfix"
              >
                <li
                  v-for="item in categories"
                  :key="`profile-system-${item.id}`"
                >
                  <v-btn
                    :class="rootCategoryClasses(item.id)"
                    @click="searchCategory(item.id)"
                  >
                    {{ item.name }}
                    <v-icon
                      v-if="item.children"
                      :class="{'alternate-icon-small': !mdiChevronDown}"
                      class="mx-auto"
                    >
                      {{ mdiChevronDown }}
                    </v-icon>
                  </v-btn>
                  <ul v-if="item.children">
                    <li
                      v-for="itemL1 in item.children"
                      :key="`profile-system-L-${itemL1.id}`"
                    >
                      <span @click="searchCategory(itemL1.id)">
                        {{ itemL1.name }}
                        <v-icon
                          v-if="itemL1.children"
                          :class="{'alternate-icon-small': mdiChevronDown}"
                          class="mx-auto arrow-icon"
                        >
                          {{ mdiChevronDown }}
                        </v-icon>
                      </span>
                      <ul v-if="itemL1.children">
                        <li
                          v-for="(itemL2, index) in itemL1.children"
                          :key="`profile-system-L2-${index}`"
                        >
                          <span @click="searchCategory(itemL2.id)">{{ itemL2.name }}</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <v-btn
                    :class="{ 'active': categorySelected === '' }"
                    elevation="2"
                    @click="searchCategory(-1)"
                  >
                    All
                  </v-btn>
                </li>
              </ul>

              <ul
                v-if="content_type || content_type === -1"
                class="list-menu clearfix"
              >
                <li
                  v-for="item in professionalCategories"
                  :key="`profile-prof-${item.id}`"
                >
                  <v-btn
                    :class="rootCategoryClasses(item.id)"
                    @click="searchCategory(item.id)"
                  >
                    {{ item.name }}
                    <v-icon
                      v-if="item.children"
                      :class="{'alternate-icon-small': !mdiChevronDown}"
                      class="mx-auto"
                    >
                      {{ mdiChevronDown }}
                    </v-icon>
                  </v-btn>
                  <ul v-if="item.children">
                    <li
                      v-for="itemL1 in item.children"
                      :key="`profile-prof-L-${itemL1.id}`"
                    >
                      <span @click="searchCategory(itemL1.id)">
                        {{ itemL1.name }}
                        <v-icon
                          v-if="itemL1.children"
                          :class="{'alternate-icon-small': mdiChevronDown}"
                          class="mx-auto arrow-icon"
                        >
                          {{ mdiChevronDown }}
                        </v-icon>
                      </span>
                      <ul v-if="itemL1.children">
                        <li
                          v-for="(itemL2, index) in itemL1.children"
                          :key="`profile-prof-L2-${index}`"
                        >
                          <span @click="searchCategory(itemL2.id)">{{ itemL2.name }}</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <v-btn
                    :class="{ 'active': categorySelected === '' }"
                    elevation="2"
                    @click="searchCategory(-1)"
                  >
                    All
                  </v-btn>
                </li>
              </ul>
            </div>
          </div>
        </v-row>

        <v-row>
          <!-- Left Sidebar -->
          <v-col
            cols="12"
            md="5"
          >
            <!-- About Card -->
            <v-card class="mb-4 profile-card">
              <v-card-title class="font-weight-bold">
                About
              </v-card-title>
              <v-card-text>
                <p
                  v-if="user.bio"
                  class="bio-text mb-4"
                >
                  {{ user.bio }}
                </p>
                <p
                  v-else
                  class="text--secondary"
                >
                  No bio available.
                </p>
                <div class="about-details">
                  <div
                    v-if="user.username"
                    class="detail-row"
                  >
                    <v-icon class="detail-icon">
                      {{ mdiAccountCircle }}
                    </v-icon>
                    <span>@{{ user.username }}</span>
                  </div>
                  <div
                    v-if="user.created_at"
                    class="detail-row"
                  >
                    <v-icon class="detail-icon">
                      {{ mdiCalendar }}
                    </v-icon>
                    <span>Member since {{ formatDate(user.created_at) }}</span>
                  </div>
                </div>
              </v-card-text>
            </v-card>

            <!-- Connections Card -->
            <v-card class="mb-4 profile-card">
              <v-card-title class="d-flex justify-space-between align-center">
                <span class="font-weight-bold">Connections</span>
                <AppBarSearch />
              </v-card-title>
              <v-card-subtitle v-if="connectionsCount > 0">
                {{ connectionsCount }} connection{{ connectionsCount !== 1 ? 's' : '' }}
              </v-card-subtitle>
              <v-card-text>
                <v-row
                  v-if="connections.length"
                  dense
                >
                  <v-col
                    v-for="(connection, idx) in connections.slice(0, 9)"
                    :key="`sidebar-conn-${idx}`"
                    cols="4"
                    class="text-center connection-item"
                    @click="goToProfile(connection.username)"
                  >
                    <v-avatar
                      size="80"
                      class="mb-1 rounded-lg cursor-pointer"
                      tile
                    >
                      <v-img
                        :src="connection.photo || defaultAvatar"
                        :alt="connection.name"
                      ></v-img>
                    </v-avatar>
                    <div class="connection-name text-body-2">
                      {{ connection.name }}
                    </div>
                  </v-col>
                </v-row>
                <p
                  v-else
                  class="text--secondary"
                >
                  No connections yet.
                </p>
              </v-card-text>
            </v-card>

            <!-- Photos Preview Card -->
            <v-card class="mb-4 profile-card">
              <v-card-title class="d-flex justify-space-between align-center">
                <span class="font-weight-bold">Pictures</span>
                <span
                  v-if="photos.length"
                  class="text-body-2 primary--text cursor-pointer"
                  @click="$router.push({ name: 'public_pictures', params: { username: $route.params.username }, query: { ...$route.query } })"
                >
                  See all pictures
                </span>
              </v-card-title>
              <v-card-text>
                <!-- Loading skeleton for photos -->
                <v-row
                  v-if="contentLoading"
                  dense
                >
                  <v-col
                    v-for="n in 9"
                    :key="`photo-skeleton-${n}`"
                    cols="4"
                  >
                    <v-skeleton-loader
                      type="image"
                      class="rounded"
                    ></v-skeleton-loader>
                  </v-col>
                </v-row>
                <v-row
                  v-else-if="photos.length"
                  dense
                >
                  <v-col
                    v-for="(photo, idx) in photos.slice(0, 9)"
                    :key="`photo-preview-${idx}`"
                    cols="4"
                  >
                    <v-img
                      :src="photo.url"
                      aspect-ratio="1"
                      class="rounded photo-thumb"
                      @click="openPhotoModal(photo)"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-1"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-col>
                </v-row>
                <p
                  v-else-if="!contentLoading"
                  class="text--secondary"
                >
                  No public pictures.
                </p>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- Right Content -->
          <v-col
            cols="12"
            md="7"
          >
            <!-- Biography Preview Card -->
            <v-card class="mb-4 profile-card">
              <v-card-title class="d-flex justify-space-between align-center">
                <span class="font-weight-bold">Biography</span>
                <span
                  v-if="biographyEntries.length"
                  class="text-body-2 primary--text cursor-pointer"
                  @click="$router.push({ name: 'public_biography', params: { username: $route.params.username }, query: { ...$route.query } })"
                >
                  See full biography
                </span>
              </v-card-title>
              <v-card-text>
                <!-- Loading skeleton for biography -->
                <template v-if="contentLoading">
                  <div
                    v-for="n in 3"
                    :key="`bio-skeleton-${n}`"
                    class="mb-4"
                  >
                    <div class="d-flex align-center mb-3">
                      <v-skeleton-loader
                        type="avatar"
                        class="me-3"
                      ></v-skeleton-loader>
                      <div style="flex: 1">
                        <v-skeleton-loader type="text" width="40%"></v-skeleton-loader>
                        <v-skeleton-loader type="text" width="25%"></v-skeleton-loader>
                      </div>
                    </div>
                    <v-skeleton-loader type="paragraph"></v-skeleton-loader>
                    <v-skeleton-loader type="image" class="mt-2 rounded"></v-skeleton-loader>
                    <v-divider
                      v-if="n < 3"
                      class="mt-4"
                    ></v-divider>
                  </div>
                </template>
                <template v-else-if="biographyEntries.length">
                  <div
                    v-for="(entry, idx) in visibleBiographyEntries"
                    :key="`bio-preview-${idx}`"
                    class="biography-preview-entry"
                  >
                    <div class="bio-preview-content">
                      <div class="d-flex align-center mb-2">
                        <v-avatar
                          size="40"
                          class="me-3"
                        >
                          <v-img
                            :src="avatarUrl"
                            :alt="user.name"
                          ></v-img>
                        </v-avatar>
                        <div>
                          <div class="font-weight-medium">
                            {{ user.name }}
                          </div>
                          <div class="text-caption text--secondary">
                            {{ formatDate(entry.updated_at) }}
                          </div>
                        </div>
                      </div>
                      <h3
                        v-if="entry.name"
                        class="text-subtitle-1 font-weight-bold mb-1"
                      >
                        {{ entry.name }}
                      </h3>
                      <p
                        v-if="entry.alternative_text"
                        class="text-body-2 mb-2"
                        v-html="truncateText(entry.alternative_text, 200)"
                      ></p>
                      <template v-if="entry.related_files && entry.related_files.length">
                        <v-img
                          v-if="isImage(entry.related_files[0])"
                          :src="entry.related_files[0]"
                          class="rounded mt-2 bio-entry-image"
                          width="100%"
                          @error="onImgError(entry.related_files[0])"
                        ></v-img>
                        <video
                          v-else-if="isVideo(entry.related_files[0])"
                          width="100%"
                          controls
                          class="rounded mt-2"
                        >
                          <source
                            :src="entry.related_files[0]"
                            :type="getVideoType(entry.related_files[0])"
                          >
                        </video>
                      </template>
                      <!-- Like Button -->
                      <div class="like-row mt-3">
                        <v-icon
                          :color="likeStatus[entry.id] ? 'red' : ''"
                          size="20"
                          class="cursor-pointer"
                          @click="toggleLike(entry)"
                        >
                          {{ likeStatus[entry.id] ? mdiHeart : mdiHeartOutline }}
                        </v-icon>
                        <span
                          v-if="likeCounts[entry.id]"
                          class="like-count cursor-pointer"
                          @click="openLikersDialog(entry.id)"
                        >{{ likeCounts[entry.id] }}</span>
                      </div>
                    </div>
                    <v-divider
                      v-if="idx < visibleBiographyEntries.length - 1"
                    ></v-divider>
                  </div>
                  <!-- Automatically reveal more entries near the end; keep the button as a fallback. -->
                  <div
                    v-if="!contentLoading && biographyEntries.length > biographyLimit"
                    :key="biographyLimit"
                    v-intersect="{ handler: onBiographyIntersect, options: { rootMargin: '400px 0px' } }"
                    class="text-center mt-4"
                  >
                    <v-btn
                      outlined
                      color="primary"
                      @click="loadMoreBiography"
                    >
                      Load more
                    </v-btn>
                  </div>
                </template>
                <p
                  v-else-if="!contentLoading"
                  class="text--secondary"
                >
                  No public biography entries.
                </p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </template>

    <!-- Photo Modal -->
    <v-dialog
      v-model="photoModal"
      max-width="900"
    >
      <v-card v-if="selectedPhoto">
        <div class="dialog-body dialog-media">
          <v-img
            :src="selectedPhoto.url"
            contain
            max-height="80vh"
          ></v-img>
          <v-card-text v-if="selectedPhoto.name">
            <h3 class="mt-2">
              {{ selectedPhoto.name }}
            </h3>
            <p
              v-if="selectedPhoto.alternative_text"
              v-html="selectedPhoto.alternative_text"
            ></p>
          </v-card-text>
          <CommentsSection
            v-if="selectedPhoto && selectedPhoto.id"
            :file-id="selectedPhoto.id"
            @count-updated="modalCommentCount = $event"
          />
        </div>
        <v-card-actions>
          <div
            v-if="selectedPhoto.id"
            class="like-action"
            @click="toggleLike(selectedPhoto)"
          >
            <v-icon
              :color="likeStatus[selectedPhoto.id] ? 'red' : ''"
              size="20"
            >
              {{ likeStatus[selectedPhoto.id] ? mdiHeart : mdiHeartOutline }}
            </v-icon>
            <span
              v-if="likeCounts[selectedPhoto.id]"
              class="like-count"
            >{{ likeCounts[selectedPhoto.id] }}</span>
          </div>
          <div
            v-if="selectedPhoto.id"
            class="comment-action d-flex align-center ml-4"
          >
            <v-icon size="20">
              {{ mdiCommentOutline }}
            </v-icon>
            <span
              v-if="modalCommentCount > 0"
              class="like-count ml-1"
            >{{ modalCommentCount }}</span>
          </div>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="photoModal = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { Intersect } from 'vuetify/lib/directives'
import {
  mdiAccountCircle,
  mdiCalendar,
  mdiChevronDown,
  mdiAccountTie,
  mdiAccount,
  mdiAccountMultiple,
  mdiHeartOutline,
  mdiHeart,
  mdiCommentOutline,
} from '@mdi/js'
import PublicProfileHeader from '@/components/PublicProfileHeader.vue'
import AppBarSearch from '@/layouts/components/AppBarSearch.vue'
import LikersDialog from '@/components/LikersDialog.vue'
import CommentsSection from '@/components/CommentsSection.vue'

import { enabled } from '../../../utils/recordPrivacy'

export default {
  name: 'PublicProfile',
  directives: { Intersect },
  components: {
    PublicProfileHeader,
    AppBarSearch,
    LikersDialog,
    CommentsSection,
  },
  data: () => ({
    mdiAccountCircle,
    mdiCalendar,
    mdiChevronDown,
    mdiAccountTie,
    mdiAccount,
    mdiAccountMultiple,
    mdiHeartOutline,
    mdiHeart,
    mdiCommentOutline,

    userLoaded: false,
    contentLoading: false,
    biographyLimit: 3,
    photoModal: false,
    selectedPhoto: null,
    modalCommentCount: 0,

    user: {
      name: '',
      username: '',
      bio: '',
      avatar: '',
      created_at: '',
    },

    connections: [],
    connectionsCount: 0,
    photos: [],
    biographyEntries: [],
    allContentItems: [],
    categories: [],
    professionalCategories: [],
    categorySelected: '',
    content_type: 0,
    failedImages: {},
    likeStatus: {},
    likeCounts: {},
    likersDialogOpen: false,
    likersDialogFileId: null,

    endpoint: process.env.VUE_APP_ROOT_API,
    defaultAvatar: require('@/assets/images/avatars/1.png'),
  }),
  computed: {
    avatarUrl() {
      if (this.user.avatar) {
        return `https://self-biography-system.s3.us-east-2.amazonaws.com/${this.user.avatar}`
      }

      return this.defaultAvatar
    },
    visibleBiographyEntries() {
      return this.biographyEntries.slice(0, this.biographyLimit)
    },
  },
  methods: {
    initializeFiltersFromRoute() {
      const queryContentType = Number.parseInt(this.$route.query.ct, 10)
      if (Number.isInteger(queryContentType)) {
        this.content_type = queryContentType
      } else {
        const storedType = Number.parseInt(localStorage.getItem('sb-shared-content-type'), 10)
        this.content_type = Number.isInteger(storedType) && [0, 1, -1].includes(storedType) ? storedType : 0
      }
      this.categorySelected = this.$route.query.cat || ''
      localStorage.setItem('sb-shared-content-type', String(this.content_type))
    },
    syncFiltersToRoute() {
      const nextQuery = { ...this.$route.query }
      localStorage.setItem('sb-shared-content-type', String(this.content_type))

      if (this.content_type === 0) {
        delete nextQuery.ct
      } else {
        nextQuery.ct = String(this.content_type)
      }

      if (this.categorySelected) {
        nextQuery.cat = String(this.categorySelected)
      } else {
        delete nextQuery.cat
      }

      const sameContentType = String(this.$route.query.ct || '') === String(nextQuery.ct || '')
      const sameCategory = String(this.$route.query.cat || '') === String(nextQuery.cat || '')
      if (!sameContentType || !sameCategory) {
        this.$router.replace({ query: nextQuery })
      }
    },
    findRootCategoryId(categories, targetId) {
      for (const category of categories) {
        if (Number(category.id) === Number(targetId)) return Number(category.id)
        if (category.children && category.children.length) {
          const nestedMatch = this.findRootCategoryId(category.children, targetId)
          if (nestedMatch !== null) return Number(category.id)
        }
      }

      return null
    },
    getSelectedRootCategoryId() {
      if (!this.categorySelected) return null
      const selectedId = Number(this.categorySelected)
      const personalMatch = this.findRootCategoryId(this.categories, selectedId)
      if (personalMatch !== null) return personalMatch

      return this.findRootCategoryId(this.professionalCategories, selectedId)
    },
    rootCategoryClasses(categoryId) {
      return {
        'root-category-active': Number(categoryId) === this.getSelectedRootCategoryId(),
      }
    },
    async onUserLoaded(userData) {
      this.initializeFiltersFromRoute()
      this.user = userData
      this.userLoaded = true
      this.contentLoading = true
      await this.loadPublicContent(this.$route.params.username)
    },

    onConnectionsLoaded(data) {
      this.connections = data.connections.map(c => ({
        ...c,
        photo: c.avatar
          ? `https://self-biography-system.s3.us-east-2.amazonaws.com/${c.avatar}`
          : this.defaultAvatar,
      }))
      this.connectionsCount = data.count
    },

    async loadPublicContent(username) {
      this.allContentItems = []
      this.applyPublicFilters()
      try {
        await this.getCategories(username)
        const response = await axios.get(
          `${this.endpoint}/getPublicItems?username=${encodeURIComponent(username)}`,
        )

        if (response.data.content) {
          this.allContentItems = response.data.content.filter(item => enabled(item.public) && enabled(item.effective_public)).map(item => {
            if (item.rotate_position) {
              item.rotate_position = typeof item.rotate_position === 'string' ? item.rotate_position.split(', ') : item.rotate_position
            } else {
              item.rotate_position = []
            }
            if (!item.related_files) {
              item.related_files = []
            }

            return item
          })

          this.applyPublicFilters()

          // Fetch like data
          this.fetchLikeData(this.allContentItems.map(i => i.id))
        }
      } catch {
        // Content loading failed silently
      }
      this.contentLoading = false
    },

    checkContentType(val) {
      this.content_type = val
      this.searchCategory(-1)
    },

    searchCategory(value) {
      this.categorySelected = value !== -1 ? value : ''
      this.biographyLimit = 3
      this.syncFiltersToRoute()
      this.applyPublicFilters()
    },

    async getCategories(username = this.$route.params.username) {
      try {
        const response = await axios.get(
          `${this.endpoint}/getPublicCategories?username=${encodeURIComponent(username)}`,
        )

        this.categories = []
        this.professionalCategories = []

        if (response.data.content) {
          response.data.content.forEach(value => {
            if (value.type) {
              if (!value.content_type) {
                if (value.active) {
                  this.categories.push(value)
                }
              } else if (value.active) {
                this.professionalCategories.push(value)
              }
            }
          })
        }
      } catch {
        // Categories loading failed silently
      }
    },

    applyPublicFilters() {
      let filtered = this.allContentItems.filter(item => enabled(item.public) && enabled(item.effective_public))

      if (this.content_type === 0) {
        filtered = filtered.filter(item => !item.content_type || item.content_type === 0)
      } else if (this.content_type === 1) {
        filtered = filtered.filter(item => item.content_type === 1)
      }

      if (this.categorySelected) {
        filtered = filtered.filter(item => {
          if (!item.categories) return false
          const categories = String(item.categories).split(', ').map(Number)

          return categories.includes(Number(this.categorySelected))
        })
      }

      filtered.sort((a, b) => (Date.parse(a.updated_at) || 0) - (Date.parse(b.updated_at) || 0) || Number(a.id) - Number(b.id))
      this.biographyEntries = filtered
      this.photos = []

      filtered.forEach(item => {
        item.related_files.forEach(file => {
          if (this.isImage(file) && !this.isVideo(file)) {
            this.photos.push({
              id: item.id,
              url: file,
              name: item.name,
              alternative_text: item.alternative_text,
            })
          }
        })
      })
    },

    onBiographyIntersect(entries, observer, isIntersecting) {
      if (isIntersecting) this.loadMoreBiography()
    },

    loadMoreBiography() {
      if (this.contentLoading || this.biographyLimit >= this.biographyEntries.length) return
      this.biographyLimit = Math.min(this.biographyLimit + 5, this.biographyEntries.length)
    },

    goToProfile(username) {
      if (username) {
        this.$router.push({ name: 'public_user', params: { username } })
      }
    },

    openPhotoModal(photo) {
      this.selectedPhoto = photo
      this.modalCommentCount = 0
      this.photoModal = true
    },

    async fetchLikeData(fileIds) {
      if (!fileIds || !fileIds.length) return
      try {
        const token = this.$store.state.jwtToken
        if (token) {
          const response = await axios.get(
            `${this.endpoint}/getLikeStatus?file_ids=${fileIds.join(',')}`,
            { headers: { Authorization: token } },
          )
          if (response.data) {
            this.likeStatus = { ...this.likeStatus, ...response.data.likeStatus }
            this.likeCounts = { ...this.likeCounts, ...response.data.likeCounts }
          }
        } else {
          // Unauthenticated - fetch counts only via getLikes for each file
          for (const id of fileIds) {
            try {
              const response = await axios.get(`${this.endpoint}/getLikes?file_id=${id}`)
              if (response.data) {
                this.$set(this.likeCounts, id, response.data.likeCount || 0)
              }
            } catch {
              // skip
            }
          }
        }
      } catch {
        // Silently fail
      }
    },

    async toggleLike(entry) {
      if (!this.$store.state.jwtToken) return
      try {
        const response = await axios.post(`${this.endpoint}/toggleLike`, {
          file_id: entry.id,
        }, {
          headers: { Authorization: this.$store.state.jwtToken },
        })
        if (response.data) {
          this.$set(this.likeStatus, entry.id, response.data.liked)
          this.$set(this.likeCounts, entry.id, response.data.likeCount)
        }
      } catch {
        // Silently fail
      }
    },
    openLikersDialog(fileId) {
      this.likersDialogFileId = fileId
      this.likersDialogOpen = true
    },

    formatDate(dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr)
      const options = { year: 'numeric', month: 'long', day: 'numeric' }

      return date.toLocaleDateString('en-US', options)
    },

    truncateText(text, maxLength) {
      if (!text) return ''
      if (text.length <= maxLength) return text

      return `${text.substring(0, maxLength)}...`
    },

    getFileExtension(filePath) {
      if (!filePath) return ''
      try {
        const pathname = new URL(filePath).pathname

        return pathname.split('.').pop().toLowerCase()
      } catch {
        return filePath.split('.').pop().split('?')[0].toLowerCase()
      }
    },

    isImage(filePath) {
      if (!filePath) return false
      const ext = this.getFileExtension(filePath)
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'tiff', 'svg', 'heic', 'heif', 'ico']
      const videoExtensions = ['mp4', 'avi', 'mov', 'mkv', 'webm', 'flv', 'wmv', 'mpg', 'mpeg']
      if (imageExtensions.includes(ext)) return true
      if (videoExtensions.includes(ext)) return false

      return false
    },

    isVideo(filePath) {
      if (!filePath) return false
      const ext = this.getFileExtension(filePath)
      const videoExtensions = ['mp4', 'avi', 'mov', 'mkv', 'webm', 'flv', 'wmv', 'mpg', 'mpeg']
      if (videoExtensions.includes(ext)) return true

      return !!this.failedImages[filePath]
    },

    onImgError(filePath) {
      this.$set(this.failedImages, filePath, true)
    },

    getVideoType(filePath) {
      const ext = this.getFileExtension(filePath)
      const types = {
        mp4: 'video/mp4',
        webm: 'video/webm',
        avi: 'video/avi',
        mov: 'video/quicktime',
        mkv: 'video/x-matroska',
        flv: 'video/x-flv',
        wmv: 'video/x-ms-wmv',
        mpg: 'video/mpeg',
        mpeg: 'video/mpeg',
      }

      return types[ext] || 'video/mp4'
    },
  },
}
</script>

<style lang="scss" scoped>
.public-profile {
  min-height: 100vh;
}

/* Body Content */
.profile-body {
  padding-top: 24px;
}

.profile-filter-row {
  margin-bottom: 4px;
}

.wrapper-menu {
  flex: 1;
  position: relative;

  .inner-wrapper-menu {
    text-align: center;
  }

  .v-btn {
    margin-bottom: 20px;
  }

  .v-btn:not(:last-child) {
    margin-right: 10px;
  }
}

.root-category-active {
  background-color: #9155fd !important;
  border-color: #9155fd !important;
  color: #fff !important;
}

.profile-card {
  border-radius: 8px;
}

.bio-text {
  font-size: 0.95rem;
  line-height: 1.5;
  white-space: pre-line;
}

/* About Details */
.about-details {
  .detail-row {
    display: flex;
    align-items: center;
    padding: 8px 0;

    .detail-icon {
      margin-right: 12px;
      opacity: 0.7;
    }
  }
}

/* Connections */
.connection-item {
  cursor: pointer;

  .connection-name {
    font-weight: 500;
    line-height: 1.2;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

/* Photos */
.photo-thumb {
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.85;
  }
}

/* Biography Preview (All tab) */
.biography-preview-entry {
  position: relative;
  padding: 16px 0;

  .bio-preview-content {
    padding-bottom: 16px;
  }

  .bio-entry-image {
    width: 100%;

    ::v-deep .v-image__image {
      background-size: cover;
    }
  }

  .like-row {
    display: flex;
    align-items: center;
  }
}

/* Cursor utility */
.cursor-pointer {
  cursor: pointer;
}

/* Like action */
.like-action {
  display: inline-flex;
  align-items: center;
  cursor: pointer;

  .v-icon {
    transition: transform 0.2s;
  }

  .like-count {
    font-size: 13px;
    margin-left: 4px;
    font-weight: 500;
  }
}

.comment-action {
  .like-count {
    font-size: 13px;
    font-weight: 500;
  }
}
</style>
